import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Features } from '../../assets/features/Features';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
    const { language } = useLanguage();
    const phoneNumber = '351914440333';
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    const message = encodeURIComponent(language === 'pt' 
        ? 'Olá! Gostaria de solicitar um orçamento.' 
        : 'Hello! I would like to request a quote.');

    return (
        <a 
            href={`${whatsappUrl}?text=${message}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-button-custom" 
            aria-label={Features.WHATSAPP.ARIA_LABEL[language]}
        >
            <div className="whatsapp-button-custom__wrapper">
                <div className="whatsapp-button-custom__circle">
                    <i className="fab fa-whatsapp whatsapp-button-custom__icon"></i>
                    <div className="whatsapp-button-custom__badge">
                        <i className="fas fa-comment-dots whatsapp-button-custom__badge-icon"></i>
                    </div>
                </div>
                <div className="whatsapp-button-custom__tooltip">
                    <span>{Features.WHATSAPP.TOOLTIP[language]}</span>
                </div>
            </div>
        </a>
    );
};

export default WhatsAppButton;

